import { useRouter } from "next/router";
import Link from "next/link";
import { Card, Row, Col, Button, Alert, Space } from "antd";
import SiteLayout from "~/components/layout/SiteLayout";
import GroupProfile from "~/components/groups/GroupProfile";
import GroupDescription from "~/components/groups/GroupDescription";
import GroupInfoSmall from "~/components/groups/GroupInfoSmall";
import GroupNavs from "~/components/groups/GroupNavs";

import { getGroups } from "~/services/groups";

const GroupListPage = ({ groups }) => {
  const router = useRouter();
  const { query } = router;

  const GroupInfo = ({ group }) => (
    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
      <div className="group-info-wrapper">
        <GroupProfile group={group} size="md" />
        <GroupDescription group={group} />
        <Link legacyBehavior href={`/groups/${group.id}`}>
          <a>
            <Button type="primary">申请入群</Button>
          </a>
        </Link>
      </div>
    </Col>
  );

  const GroupInfoSm = ({ group }) => (
    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
      <Link legacyBehavior href={`/groups/${group.id}`}>
        <a>
          <GroupInfoSmall group={group} />
        </a>
      </Link>
    </Col>
  );

  return (
    <SiteLayout
      pageTitle="群组"
      pageSider={<GroupNavs active={query.category} />}
      siderOptions={{
        position: "left",
        size: "sm",
      }}>
      <Card>
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Alert
            message="每推荐收录成功一个群，可得20电量；每个用户最多只可申请加入3个群"
            type="info"
            showIcon
          />

          <Row gutter={[24, 24]}>
            {groups &&
              groups
                .filter((g) => g.pinned)
                .map((group) => <GroupInfo key={group.id} group={group} />)}
            {groups &&
              groups
                .filter((g) => !g.pinned)
                .map((group) => <GroupInfoSm key={group.id} group={group} />)}
          </Row>
        </Space>
      </Card>
    </SiteLayout>
  );
};

GroupListPage.requireUser = () => false;

GroupListPage.getInitialProps = async (ctx) => {
  let groups = await getGroups(ctx.query.category);
  groups = groups.sort((a, b) => b.featured - a.featured);

  return { groups };
};

export default GroupListPage;
